import Observer from 'common/scripts/observer';
import Swiper from 'swiper/js/swiper.min';

const observer = new Observer();
const residentialListElements = Array.from(document.querySelectorAll('.j-residential-list'));
const optionsResidentialList = {
    wrapperClass          : 'j-residential-container',
    slideClass            : 'j-residential-slide',
    slidesPerView         : 'auto',
    containerModifierClass: 'swiper-container-',
    scrollbar             : {
        el       : '.j-residential-scrollbar',
        draggable: true
    }
};

if (residentialListElements.length) {
    /* eslint-disable no-new */
    new Swiper('.j-residential-list', optionsResidentialList);
    /* eslint-enable no-new */
}

observer.subscribe('residential-list:refresh', (container, startWith) => {
    const slider = container.querySelector('.j-residential-list');

    if (slider) {
        /* eslint-disable no-new */
        const swiper = new Swiper(slider, optionsResidentialList);

        swiper.slideTo(startWith);
        /* eslint-enable no-new */
    }
});
